
import "./Pricing.css";

const About = (props) => {
  const { onLogin } = props;
  return (
    <div className="unauthed-home-container">
      <div className="unauthed-home-container-title">
        Pricing
      </div>
    </div>
  );
};

export default About;
